/**
 * Serialize only identity and display fields needed to restore a session.
 * Authorization flags are intentionally excluded and must be rebuilt from the
 * access token or profile API after the application starts.
 */
export function serializeUserForStorage<T extends object>(user: T): string {
  const source = user as Record<string, unknown>

  return JSON.stringify({
    id: source.id,
    email: source.email,
    firstName: source.firstName,
    lastName: source.lastName,
    name: source.name,
    sid: source.sid,
    legacyUserpk: source.legacyUserpk,
    emailVerified: source.emailVerified,
    isEmailVerified: source.isEmailVerified,
    isActive: source.isActive,
    isDeleted: source.isDeleted,
    profilePictureUrl: source.profilePictureUrl,
    picture: source.picture,
    authenticatedVia: source.authenticatedVia,
    orgId: source.orgId,
    siteId: source.siteId,
    locationId: source.locationId,
    locationOrganizationId: source.locationOrganizationId,
    locationSiteId: source.locationSiteId,
  })
}
